import debouncedSaveTemplate from 'fantastic/lib/debouncedSaveTemplate';

const findDestinationIndex = (sections, target) => {
  const destinationIndex = sections.findIndex((item) => item.id === target.id);
  return target.place === "down" ? destinationIndex + 1 : destinationIndex - 1;
};

const getSelectedId = (sections, target) => {
  if (!target.id) {
    return (target.place === 'down' ? sections.at(-1) : sections.at(0))?.id;
  }

  const destinationIndex = findDestinationIndex(sections, target);
  const selectedElement = sections.at(destinationIndex);
  return selectedElement?.id;
};

export default ({ data }) =>
  (dispatch, getState) => {
    const { target } = window;
    dispatch({ type: 'SECTIONS/ADD', payload: { data, target } });

    const sections = getState().sections;
    const selectedId = getSelectedId(sections, target);

    if (selectedId) {
      dispatch({ type: 'SELECTED_NODE/SET', payload: selectedId });
      dispatch({ type: 'SECTIONS/NODE/SELECTED', payload: { id: selectedId, selected: true } });
    }

    debouncedSaveTemplate(dispatch, getState);
  };
